import UseResponsive from "@/utils/hooks/useResponsive";
import ComponentPrizePool from "./components/PrizePool";

export default function PrizePool() {
  return (
    <UseResponsive>
      <ComponentPrizePool />
    </UseResponsive>
  );
}
